import * as React from "react";
import { connect } from "react-redux";
import idssStyle from "../../Configuration/SharedStyling";
import { Typography, Fade, Paper, Button, Tooltip, Dialog, Divider, DialogContent, DialogActions } from "@mui/material";
import SharedMaterialReactTable, { ISharedTableColumn } from "../Shared/MaterialReactTable";
import { createStyles, Theme } from '@mui/material/styles';;
import { withStyles, WithStyles } from '@mui/styles';;
import AdministrationService from "../Services/AdministrationService";
import * as validator from "validator";
import { AjaxError } from "rxjs/ajax";
import { firstValueFrom } from "rxjs";
import { IGenericUserProps, genericMapStateToProps } from "../../DataClasses/GenericUser";
import DeleteIcon from '@mui/icons-material/Delete';
import PrivacyTipOutlinedIcon from '@mui/icons-material/PrivacyTipOutlined';
import { AddCircle} from "@mui/icons-material";
import AlertDialog from "../Shared/AlertDialog";
import { Redirect } from "react-router-dom";
import { SeedTime } from "../../Configuration/Setting";
import ErrorDialog from '../Shared/ErrorDialog';
import { IInvalidAuditor } from "../../DataClasses/AdministrationData";

const styles = (theme: Theme) => createStyles({
    ...idssStyle(theme)
});

type IStylesProps = WithStyles<typeof styles>;

export interface IDialogProperties {
    description: string;
    title: string;
    user: string;
}
export interface IAuditorsListViewStateStore {
    auditors: any[];
    isLoading: boolean;
    filterText: string;
    errorMsg: string;
    isProcessing: boolean;
    deleteAuditorConfirmDialogOpen: boolean;
    deleteAuditorDialog: IDialogProperties,
    redirect: boolean,
    auditorEmail: string,
    invalidAuditorsPopupOpen?: boolean;
    invalidAuditors?: IInvalidAuditor[];
    isLoadingInvalidAuditors?: boolean;
}

function TabContainer(props) {
    return (
        <Typography component="div" style={{ padding: 3 * 3 }}>
            {props.children}
        </Typography>
    );
}

// VIEW
class AuditorsView extends React.Component<
    IGenericUserProps & IStylesProps,
    IAuditorsListViewStateStore
> {
    constructor(props: IGenericUserProps & IStylesProps) {
        super(props);
        this.state = {
            auditors: [],
            isLoading: true,
            filterText: "",
            deleteAuditorConfirmDialogOpen: false,
            deleteAuditorDialog: {
                description: "",
                title: "",
                user: ""
            },
            errorMsg: "",
            redirect: false,
            isProcessing: false,
            auditorEmail: "",
            invalidAuditorsPopupOpen: false,
            invalidAuditors: [],
            isLoadingInvalidAuditors: false
        };
    }

    public async componentDidMount() {
        // This method runs when the component is first added to the page
        await this.RefreshModel();
    }

    private redirectToErrorPage() {
        return <Redirect to='/errorpage' />;
    }

    private setRedirectState() {
        this.setState({ redirect: true });
    }

    private actionBodyTemplate = (rowData: any) => {
        const { classes } = this.props;
        return (
            <DeleteIcon
                className={classes.actionIcon}
                onClick={() => this.ShowAuditorDeleteDialog(rowData.auditor)}
            />
        );
    };

    // Define table columns
    private getTableColumns = (): ISharedTableColumn<any>[] => [
        {
            accessorKey: 'auditor',
            header: 'Auditor',
            enableSorting: true,
            enableFiltering: true,
            size: 470,
        },
        {
            accessorKey: 'action' as any,
            header: 'Action',
            enableSorting: false,
            enableFiltering: false,
            enableColumnActions: false,
            size: 80,
            Cell: ({ row }) => this.actionBodyTemplate(row.original),
        },
    ];

    public render() {
        if (this.state.redirect) {
            return this.redirectToErrorPage();
        }
        const { classes } = this.props;

        return (
            <>
                <TabContainer>
                    <Paper className={classes.paper} style={{ width: '703px' }}>
                        <ErrorDialog
                            showError={this.state.errorMsg !== ""}
                            errorMsg={this.state.errorMsg}
                            buttonHandler={() => this.setState({ errorMsg: "" })}
                        />

                        <table><tbody><tr><td style={{ width: '488px', paddingRight: '5px', paddingLeft:'5px' }}>
                            <input
                                type="text"
                                value={this.state.auditorEmail}
                                onChange={this.handleTextChange}
                                style={{ width: '488px', height: '35px' }}
                                placeholder="Enter auditor email"
                            />
                        </td>
                            <td>
                                <Button variant='contained' color='secondary' onClick={() => {
                                    this.addAuditor(this.state.auditorEmail)
                                }} className={classes.button} startIcon={<AddCircle />} disabled={this.state.auditorEmail === ""}>
                                    Add Auditor
                                </Button>
                            </td>
                            <td style={{ width: '40px', paddingRight: '5px', paddingLeft:'15px' }}>
                                <Tooltip title="Show invalid auditors" aria-label="Show invalid auditors">
                                    <PrivacyTipOutlinedIcon
                                        className={classes.actionIcon}
                                        onClick={() => this.GetInvalidAuditors()}
                                    />
                                </Tooltip>
                            </td>
                        </tr></tbody></table>
                    </Paper>
                    <Dialog
                        open={this.state.invalidAuditorsPopupOpen}
                        onClose={() => this.CloseInvalidAuditorsDialog()}
                        classes={{ paper: classes.dialogM }}
                    >
                        <DialogContent>
                            <SharedMaterialReactTable
                                title="Invalid Auditors"
                                isLoading={this.state.isLoadingInvalidAuditors}
                                enableDownloadCsv={true}
                                data = {this.state.invalidAuditors || []}
                                columns = {this.getInvalidAuditorsColumns()}
                                enableSorting={true}   
                                emptyMessage="No Invalid Auditors."
                                layoutMode="fixed"
                                initialState={{
                                    pagination: { pageIndex: 0, pageSize: 10 },
                                }}
                            />
                        </DialogContent>
                        <Divider/>
                        <DialogActions>
                            <Button onClick={() => this.CloseInvalidAuditorsDialog()} color="primary">
                                Close
                            </Button>
                        </DialogActions>
                    </Dialog>
                        <Paper className={classes.paper} style={{ width: '703px' }}>
                            <Fade in={true} {...({ timeout: SeedTime })}><div>
                                <SharedMaterialReactTable
                                    data={this.state.auditors}
                                    columns={this.getTableColumns()}
                                title="Auditors"
                                isLoading={this.state.isLoading}
                                enablePagination={true}
                                enableSorting={true}
                                enableFiltering={true}
                                enableColumnActions={true}
                                enableRowActions={false}
                                layoutMode="fixed"
                                initialState={{
                                    pagination: { pageIndex: 0, pageSize: 10 },
                                }}
                                muiPaginationProps={{
                                    rowsPerPageOptions: [10, 15, 20, 25, 50, 75, 100, 500, 1000],
                                }}
                                emptyMessage="No auditors found."
                            />
                        </div></Fade>
                        <AlertDialog
                            showDialog={this.state.deleteAuditorConfirmDialogOpen}
                            title={this.state.deleteAuditorDialog.title}
                            description={this.state.deleteAuditorDialog.description}
                            button1Text="Delete Auditor"
                            button2Text="Cancel"
                            button1Handler={this.DeleteAuditor}
                            button2Handler={() => this.CloseDeleteAuditorConfirmDialog()}
                            isButton1Clicked={this.state.isProcessing}
                        />
                    </Paper>
                </TabContainer>
            </>
        );
    }

    private getInvalidAuditorsColumns = (): ISharedTableColumn<IInvalidAuditor>[] => [
        { accessorKey: 'email', header: 'Email', size: 180 },
        { accessorKey: 'reason', header: 'Reason', size: 200 }
    ];
    private GetInvalidAuditors = async () => {
        this.setState({ invalidAuditorsPopupOpen: true, isLoadingInvalidAuditors: true });
        const retVal = await firstValueFrom(
            AdministrationService.GetInvalidAuditors$(this.props.user)
        );
        if (retVal instanceof AjaxError || !retVal) {
            this.setRedirectState();
        }
        else {
            this.setState({invalidAuditors: retVal, isLoadingInvalidAuditors: false });
        }
    }
    private CloseInvalidAuditorsDialog = () => {
        this.setState({ invalidAuditorsPopupOpen: false, invalidAuditors: [] });
    }
    private async RefreshModel() {
        this.setState({ isLoading: true });
        const retVal = await firstValueFrom(
            AdministrationService.GetAllAuditors$(this.props.user)
        );
        if (retVal instanceof AjaxError || !retVal) {
            this.setRedirectState();
        }
        else {
            const auditors = retVal.map(item => ({
                auditor: item
            }));
            this.setState({
                auditors: auditors
            });

            this.setState({ isLoading: false });
        }
    }

    private validate = (userEmail: string): boolean => {
        var error = "";
        if (validator.isEmpty(userEmail)) {
            error = "Required";
        } else if (!validator.isLength(userEmail, { min: 1, max: 100 })) {
            error = "Email can be no longer than 100 characters";
        } else if (!validator.isEmail(userEmail)) {
            error = "Email is not in a valid format";
        }

        this.setState({ errorMsg: error });
        if (error === "") {
            return true;
        }
        return false;
    };

    private handleTextChange = (event: any) => {
        this.setState({ auditorEmail: event.target.value.trim() });
    }

    private addAuditor = async (userEmail: string) => {
        if (!this.validate(userEmail)) {
            return false;
        }
        try {
            this.setProcessingState(true);
            const addResp = await firstValueFrom(
                AdministrationService.AddAuditor(
                    this.props.user,
                    this.state.auditorEmail
                )
            );

            if (addResp instanceof AjaxError || !addResp) {
                this.setRedirectState();
            }
            else {
                this.RefreshModel();
                this.setState({ auditorEmail: "" });
            }
        } catch (ex) {
        } finally {
            this.setProcessingState(false);
        }
    }

    private DeleteAuditor = async () => {
        try {
            this.setProcessingState(true);
            const deleteResp = await firstValueFrom(
                AdministrationService.DeleteAuditor(
                    this.props.user,
                    this.state.deleteAuditorDialog.user
                )
            );

            if (deleteResp instanceof AjaxError || !deleteResp) {
                this.setRedirectState();
            }
            else {
                this.RefreshModel();
                this.CloseDeleteAuditorConfirmDialog();
            }
        } catch (ex) {
        } finally {
            this.setProcessingState(false);
        }
    }

    private setProcessingState = (value: boolean) => {
        this.setState({ isProcessing: value });
    }

    private ShowAuditorDeleteDialog = (userEmail) => {
        this.setState({
            deleteAuditorConfirmDialogOpen: true,
            deleteAuditorDialog: {
                title: "Delete Auditor " + userEmail + "?",
                description: "Are you sure you'd like to delete auditor " + userEmail + 
                "?  This action will remove the user from all auditor roles across assigned organization(s) and/or submission(s).",
                user: userEmail
            }
        });
    }

    private CloseDeleteAuditorConfirmDialog = () => {
        this.setState({
            deleteAuditorConfirmDialogOpen: false
        });
    }
}

// REDUX CONTAINER
const AuditorListPageWithState = connect<IGenericUserProps>(
    genericMapStateToProps
)(AuditorsView);

// STYLES CONTAINER
const AuditorListPage = withStyles(styles)(AuditorListPageWithState);

export default AuditorListPage;
